module.exports = __webpack_public_path__ + "static/media/glacialindifference-bold-webfont.d3a541f7.woff2";